import service from "@/store/services/reseller-services-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  resellerService: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, resellerService) => {
    state.resellerService = resellerService;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((resellerService) => {
      commit("SET_RESOURCE", resellerService);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((resellerService) => {
      commit("SET_RESOURCE", resellerService);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((resellerService) => {
      commit("SET_RESOURCE", resellerService);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  resellerService: (state) => state.resellerService,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((resellerService) => ({
      id: resellerService.id,
      name: resellerService.name,
    }));
  },
};

const resellerServices = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default resellerServices;
